<template>
  <el-dialog
      v-el-drag-dialog
      class="printProductionCardModal"
      :visible.sync="dialogVisible"
      title="打印产品标识卡"
      width="800px">
    <div v-for="(item, index) in tableData" id="printProductionCard" :key="index">
      <table cellpadding="0" cellspacing="0">
        <tr>
          <td rowspan="3">
            <div :id="'qrCode' + item.batchRowNo" align="center"/>
          </td>
          <td colspan="3" style="text-align: center; font-weight: 700; font-size: 12px"></td>
        </tr>
        <tr>
          <td colspan="3">工单：{{productInfo.productionOrderNo}}</td>
        </tr>
        <tr>
          <td colspan="3">派工单：{{productInfo.billNo}}</td>
        </tr>
        <tr>
          <td>数量：{{item.quantity}}</td>
          <td>单位：{{productInfo.unitName}}</td>
          <td colspan="2">物料号：{{productInfo.materialNo}}</td>
        </tr>
        <tr>
          <td colspan="4">物料名称：{{productInfo.materialName}}</td>
        </tr>
        <tr>
          <td colspan="4">规格：{{productInfo.specification}}</td>
        </tr>
        <tr>
          <td colspan="4">工艺路线：{{productInfo.routingName}}</td>
        </tr>
        <tr>
          <td colspan="4">
            状态：
            <el-checkbox>合格</el-checkbox>
            <el-checkbox>不合格</el-checkbox>
            <el-checkbox>已检验待判定</el-checkbox>
            <el-checkbox>未检验</el-checkbox>
          </td>
        </tr>
        <tr>
          <td colspan="2">作业员：</td>
          <td colspan="2">QC：</td>
        </tr>
        <tr>
          <td colspan="2">开工时间:{{productInfo.planStartTime}}</td>
          <td colspan="2">完工时间:{{productInfo.planFinishTime}}</td>
        </tr>
        <tr>
          <td colspan="2">销售单号:{{productInfo.salesOrderNo}}</td>
          <td colspan="2">ERP单号:{{productInfo.erpSalesOrderNo}}</td>
        </tr>
        <tr>
          <td colspan="4">合同号:{{productInfo.customerContractNo}}</td>
        </tr>
        <tr>
          <td colspan="4">项目名称:{{productInfo.projectName}}</td>
        </tr>
        <tr>
          <td colspan="4">客户名称:{{productInfo.customerName}}</td>
        </tr>
        <tr>
          <td colspan="2">检验日期：</td>
          <td colspan="2">生产日期：{{item.prodTime ? item.prodTime.substring(0, 10) : ""}}</td>
        </tr>
      </table>
    </div>
    <span slot="footer">
      <el-button @click="dialogVisible = false">关闭</el-button>
      <el-button type="primary" @click="print">打印</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import QRCode from "qrcodejs2";
  export default {
    data() {
      return {
        productInfo: {},
        dialogVisible: false,
        tableData: [],
      };
    },

    methods: {
      open(tableData, productInfo) {
        this.dialogVisible = true;
        this.productInfo = productInfo;
        this.tableData = tableData;
        for (let item of this.tableData) {
          this.$nextTick(() => {
            document.getElementById("qrCode" + item.batchRowNo).innerHTML = "";
            this.bindQRCode(item.batchRowNo);
          });
        }
      },

      bindQRCode(row) {
        let text = row;
        new QRCode(document.getElementById("qrCode" + row), {
          text: text,
          width: 80,
          height: 80,
          colorDark: "#333333", //二维码颜色
          colorLight: "#ffffff", //二维码背景色
          correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
        });
      },

      print() {
        document.body.innerHTML = document.getElementById("printProductionCard").parentNode.innerHTML;
        window.print();
        window.location.reload();
        return false;
      },
    },
  };
</script>

<style lang="scss">
.printProductionCardModal .el-dialog__header {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 99999;
  box-sizing: border-box;
}
.printProductionCardModal .el-dialog__footer {
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 99999;
  box-sizing: border-box;
  background-color: #fff;
}

.printProductionCardModal .el-dialog {
  margin: 2% auto !important;
  transform: scale3d(1, 1, 1);
  padding-top: 30px;
  padding-bottom: 39px;
  height: 90%;
}

.printProductionCardModal .el-divider--horizontal {
  margin: 10px 0;
}

.printProductionCardModal .el-dialog .el-dialog__body {
  height: 100%;
  background-color: #fff;
  overflow: scroll;
}
</style>
<style lang="scss" scoped>
#printProductionCard {
  width: 96mm;
  height: 146mm;
  margin: 0 auto;
  margin-top: 1.5mm;
  font-size: 10px;
  table {
    width: 100%;
    height: 100%;
    page-break-after: always;
    td {
      border: 1px solid #111;
      border-bottom: 0;
      border-right: 0;
      padding: 1mm;
      box-sizing: border-box;
      height: 7mm;
    }
    tr:last-child td {
      border-bottom: 1px solid #111;
    }
    tr td:last-child {
      border-right: 1px solid #111;
    }
  }
}
</style>

<style lang="scss">
#printProductionCard {
  .el-checkbox {
    margin-right: 5px;
    .el-checkbox__label {
      padding-left: 5px !important;
      font-size: 10px;
    }
    .el-checkbox__input {
      .el-checkbox__inner {
        border: 1px solid #606266 !important;
      }
    }
  }
}
</style>
